<template>
  <v-container fluid grid-list-lg>
    <Create :CustomerId="CustomerId" :createDialog="createDialog" @close="createDialog = false" @submit="getList()">
    </Create>
    <AttachInvoice :selectedAdvancePayment="selectedAdvancePayment" :attachInvoiceDialog="attachInvoiceDialog" @close="closeAttachInvoiceDialog()" @submit="allocationSaved">
    </AttachInvoice>
    <v-card :loading="loading" outlined>
      <ListTitle :access="checkRightStatus(31) && CustomerId" title="Advance tuition credit" @add="add" />
      <v-card-text class="pb-0">
        <v-alert text color="primary" icon="mdi-cash-clock" class="mb-0">
          Available credit: <strong>{{ fullTotalBalance | currency }}</strong>. New department tuition invoices use this balance before any card collection.
        </v-alert>
      </v-card-text>
      <v-card-text class="mb-0 pb-0">
        <v-row>
          <v-col cols="12" md="3" sm="12">
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable>
            </v-text-field>
          </v-col>
          <v-spacer> </v-spacer>
          <v-col cols="12" md="3" sm="12" v-if="!showAll">
            <DateTimePicker defaultRange="thisYear" :range="true" v-model="dateTime" @submit="getList()" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-data-table :headers="headers" :items="advancePayments" :search="search" :loading="loading"
          @current-items="updateTotal" :sort-by="sortBy" sort-desc :page.sync="page" :expanded.sync="expanded"
          show-expand :items-per-page="itemsPerPage">
          <template v-slot:item="{ item, isExpanded, expand }">
            <tr>
              <td class="text-left pointer">
                <v-btn @click="expand(true)" icon v-if="!isExpanded">
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
                <v-btn @click="expand(false)" icon v-if="isExpanded">
                  <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
              </td>
              <td class="text-left">
                {{ item.createdAt | moment("MM/DD/YYYY hh:mm A") }}
              </td>
              <td class="text-left">
                {{ item.localId }}
                <v-chip color="pink" dark small class="ml-2" v-if="item.donation">Donation</v-chip>
              </td>
              <td class="text-left">
                {{ item.note }}
              </td>
              <td class="text-right">
                {{ item.amount | currency }}
              </td>
              <td class="text-right">
                {{ item.balance | currency }}
              </td>
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="attachInvoice(item)">
                      <v-list-item-title>Attach Invoice</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.amount === item.balance" @click="deletePayment(item)">
                    <v-list-item-title>Delete Payment</v-list-item-title>
                  </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-card color="#F3F8FC" text class="elevation-0">
                <v-card-text class="title">
                  <AdvancePaymentDetail :AdvancePaymentId="item.id" ></AdvancePaymentDetail>
                </v-card-text>
              </v-card>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>

          <template v-slot:body.append="{ headers }">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td :colspan="headers.length - 3" class="text-right font-weight-bold">
                List Total
              </td>
              <td class="text-right font-weight-bold">
                {{ totalAmount | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ totalBalance | currency }}
              </td>
              <td></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td :colspan="headers.length - 3" class="text-right font-weight-bold">
                Result Total
              </td>
              <td class="text-right font-weight-bold">
                {{ fullTotalAmount | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ fullTotalBalance | currency }}
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import advancePaymentService from "../service";
const DateTimePicker = () => import("@/components/DateTimePicker");
import AdvancePaymentDetail from "./DetailList";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const AttachInvoice = () => import("./AttachInvoice");

export default {
  props: {
    CustomerId: {
      default: null,
    },
    showAll: {
      default: false,
    },
  },
  name: "advance-payment-list",
  data() {
    return {
      fullTotalAmount: 0,
      fullTotalBalance: 0,
      totalAmount: 0,
      totalBalance: 0,
      expanded: [],
      dateTime: {
        start: this.$moment()
          .startOf("year")
          .toISOString(),
        end: this.$moment()
          .endOf("year")
          .toISOString(),
      },
      createDialog: false,
      attachInvoiceDialog: false,
      selectedAdvancePayment: null,
      headers: [],
      advancePayments: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "localId",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.$events.listen("advancePaymentListEvent", () => this.getList());
    this.loadHeader();
  },
  beforeDestroy() {
    this.$events.remove("advancePaymentListEvent");
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    CustomerId: {
      immediate: true,
      handler() {
        this.getList();
      },
    },
  },
  components: {
    DateTimePicker,
    Create,
    AttachInvoice,
    AdvancePaymentDetail,
  },
  methods: {
    updateTotal(val) {
      this.totalAmount = 0;
      this.totalBalance = 0;
      val.map((row) => {
        this.totalAmount += row.amount;
        this.totalBalance += row.balance;
      });
    },
    add() {
      this.createDialog = true;
    },
    attachInvoice(row) {
      this.selectedAdvancePayment = row
      this.attachInvoiceDialog = true
    },
    loadHeader() {
      this.headers = [];
      this.headers.push({
        text: this.$t("labels.date"),
        align: "left",
        value: "date",
        sortable: true,
      });

      this.headers.push({
        text: "Receipt Number",
        align: "left",
        value: "localId",
        sortable: true,
      });

      this.headers.push({
        text: "Note",
        align: "left",
        value: "note",
        sortable: true,
      });

      this.headers.push({
        text: "Amount",
        value: "amount",
        align: "right",
        sortable: true,
      });

      this.headers.push({
        text: "Balance",
        value: "balance",
        align: "right",
        sortable: true,
      });

      this.headers.push({
        text: "",
        value: "action",
        sortable: false,
      });
    },
    closeAttachInvoiceDialog(){
      this.selectedAdvancePayment = null
      this.attachInvoiceDialog = false
    },
    allocationSaved() {
      return this.getList();
    },
    getList() {
      this.loading = true;
      let where = {};
      if (!this.showAll) {
        where = {
          start: this.dateTime.start,
          end: this.dateTime.end,
        };
      }
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }

      return advancePaymentService.getAll(where).then((response) => {
        this.loading = false;
        this.advancePayments = response.data;
        this.fullTotalAmount = 0;
        this.fullTotalBalance = 0;
        if(this.advancePayments.length){
          this.advancePayments.map((row) => {
            this.fullTotalAmount += row.amount;
            this.fullTotalBalance += row.balance;
          });
        }
        return response;
      });
    },
    deletePayment(payment) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          advancePaymentService.delete(payment.id).then((response) => {
            if (response.data) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Payment has been deleted.",
                });
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
